import React from 'react'

import { useTheme } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'
import { FlexDiv } from '../../components'
import { getCurrency, getLongFormDate } from '../../helpers/stringHelpers'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'

export const LeaseSummary = () => {
    const theme = useTheme()
    const selectedLease = useSelector(
        (state: RootState) => state.lease.selectedLease,
    )

    return (
        <Box
            sx={{
                backgroundColor: '#2a2f35',
                borderRadius: 2,
                padding: 3,
                marginBottom: 3,
            }}
        >
            <Typography
                variant="h6"
                style={{ color: '#fff', marginBottom: theme.spacing(2) }}
            >
                Lease Summary
            </Typography>
            {selectedLease ? (
                <FlexDiv
                    style={{ justifyContent: 'space-between', marginRight: 3 }}
                >
                    <div>
                        <Typography
                            variant="caption"
                            style={{ color: '#8b949e' }}
                        >
                            Lease Start
                        </Typography>
                        <Typography style={{ color: '#fff' }}>
                            {getLongFormDate(selectedLease.start_date)}
                        </Typography>
                    </div>
                    <div>
                        <Typography
                            variant="caption"
                            style={{ color: '#8b949e' }}
                        >
                            Lease End
                        </Typography>
                        <Typography style={{ color: '#fff' }}>
                            {getLongFormDate(selectedLease.end_date)}
                        </Typography>
                    </div>
                    <div>
                        <Typography
                            variant="caption"
                            style={{ color: '#8b949e' }}
                        >
                            Unit - Bed Space
                        </Typography>
                        <Typography style={{ color: '#fff' }}>
                            {selectedLease.area.unit_name} - {selectedLease.area.area_label}
                        </Typography>
                    </div>
                </FlexDiv>
            ) : (
                <Typography style={{ color: '#8b949e' }}>
                    No lease selected
                </Typography>
            )}
        </Box>
    )
}
